//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import QfModalModels from "../../qf-modal-models.vue";
import PropertiesUtils from "../../mixins/properties-utils";

export default {
    name: "QfPGet",
    components: { QfModalModels },
    mixins: [PropertiesUtils],
    props: {
        value: { type: String, default: null },
        label: { type: String, default: "Get data" }
    },
    data() {
        return {
            localValue: null,
            showModal: false,
            constraints: null,
            basePath: null,
            actions: [
                { icon: "mdi-file-tree", handler: () => { this.openModel(); } },
                { icon: "mdi-close-circle", content: true, handler: () => { this.clearValue(); } }
            ]
        };
    },
    computed: {
        ...mapState("components", ["activeComponent", "properties", "components"]),
        ...mapGetters("components", ["activeComponentParent"]),
        helper() {
            return this.isDisabled ? "Select master data model first" : null;
        },
        isDisabled() {
            let disabled = false;
            const parentGuid = this.__firstNamespaceParent(this.activeComponent);
            if (parentGuid) {
                const properties = this.properties[parentGuid];
                disabled = !properties.get;
            }
            return disabled;
        }
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            },
            immediate: true
        },
        localValue(val) {
            this.$emit("input", val);
        }
    },
    methods: {
        openModel() {
            if (!this.isDisabled) {
                const constraints = {};
                const properties = this.properties[this.activeComponent];
                const config = this.components[properties.__component];
                const parentGuid = this.__firstNamespaceParent(this.activeComponent);

                if (parentGuid) {
                    this.basePath = this.properties[parentGuid].get;
                }

                if (config.namespace) {
                    constraints.segment = true;
                }

                if (config.hasOwnProperty("dataModel")) {
                    const modelConstraints = config.dataModel;

                    if (modelConstraints.list) {
                        constraints.list = true;
                    }

                    if (modelConstraints.attachment) {
                        constraints.attachment = true;
                    }

                    if (modelConstraints.catalogs) {
                        constraints.catalog = true;
                    }

                    if (modelConstraints.types) {
                        if (modelConstraints.types.constructor === Array) {
                            constraints.types = [...modelConstraints.types];
                        } else {
                            constraints.types = [properties[modelConstraints.types]];
                        }
                    }
                }

                this.constraints = Object.keys(constraints).length ? constraints : null;
                this.showModal = true;
            }
        },
        clearValue() {
            if (this.properties[this.activeComponent].__generics.mapLink) {
                this.__resetComponentModel(this.activeComponent, { get: true, set: true });
            } else {
                this.__resetComponentModel(this.activeComponent, { get: true });
            }
        },
        getUpdate(newData) {
            this.localValue = newData;
        }
    }
};
